import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Radio } from 'antd';
import styles from './styles';

export const RBHRadio = (p: any) => {
  let style = p.style;
  if (p.disabled) {
    style = { ...p.style, ...styles.disabled };
  }
  return (
      <Radio
        style={p.style ? p.style : style}
        value={p.value}
        disabled={p.disabled}
        id={p.id}
        data-testid={p['data-testid']}
      >
        {p.textOption ? <FormattedMessage id={p.textOption} /> : null}
        {p.children}
      </Radio>
  );
};

export default RBHRadio;
